import { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Row, Logo } from 'components/lib';
import { authClient } from '../../../lib/auth-client';
import { UMButton } from '@urbanmetrix/um-kit';
import { getApiErrorMessage } from 'api/apiClient';

export function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isDisabled = useMemo(() => {
    return !token || !newPassword || !confirmNewPassword || isSubmitting;
  }, [confirmNewPassword, isSubmitting, newPassword, token]);

  async function handleResetPassword() {
    if (!token) {
      setError('Missing reset token.');
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError('Passwords do not match.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      await authClient.resetPassword({
        newPassword,
        token,
        fetchOptions: { throw: true },
      });

      navigate('/login', { replace: true });
    } catch (resetError) {
      setError(getApiErrorMessage(resetError, 'Unable to reset password.'));
      setIsSubmitting(false);
    }
  }

  return (
    <Row title="Reset your password" customClass="auth-form-row">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '15px',
        }}
      >
        <Logo />
      </div>

      <Card restrictWidth center extraClass="form-container" isStat={true}>
        <div style={{ display: 'grid', gap: '12px' }}>
          <input
            type="password"
            placeholder="New password"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            className="w-full rounded-full border-0 bg-white/35 px-4 py-3 outline-none"
          />

          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmNewPassword}
            onChange={(event) => setConfirmNewPassword(event.target.value)}
            className="w-full rounded-full border-0 bg-white/35 px-4 py-3 outline-none"
          />

          {error && <p style={{ marginBottom: 0, color: '#b42318' }}>{error}</p>}

          <UMButton
            text={isSubmitting ? 'Resetting...' : 'Reset password'}
            onClick={handleResetPassword}
            disabled={isDisabled}
            fullWidth
          />
        </div>
      </Card>
    </Row>
  );
}
